import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '@app/core/services/loader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgIf } from '@angular/common';

@UntilDestroy()
@Component({
  selector:        'app-loader',
  templateUrl:     './loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [NgIf]
})
export class LoaderComponent implements OnInit {
  public loading: boolean;

  @Input()
  global = false;

  @Input()
  dotted = false;

  constructor(private loaderService: LoaderService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    if (this.global) {
      this.loaderService.isLoading.pipe(untilDestroyed(this))
        .subscribe(v => {
          this.loading = v;
          this.cd.markForCheck();
        });
    } else {
      // Immer einblenden, Komponente soll entscheiden
      this.loading = true;
    }
  }


}
